// extracted by mini-css-extract-plugin
module.exports = {"description":"_1dV5xDULkv6QKP1-XDAJOq"};